import React from "react";
import { cn } from "../../lib/utils";
import type { SnackBarContent } from "./types";

interface SnackBarProps {
  content: SnackBarContent;
  onClose: () => void;
}

export default function SnackBar({ content, onClose }: SnackBarProps) {
  if (!content.open) return null;

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className={cn(
        "rounded-lg px-4 py-3 shadow-lg flex items-center gap-2 min-w-[300px]",
        content.severity === "error" && "bg-red-50 text-red-800 border border-red-200",
        content.severity === "success" && "bg-green-50 text-green-800 border border-green-200",
        content.severity === "warning" && "bg-yellow-50 text-yellow-800 border border-yellow-200",
        content.severity === "info" && "bg-blue-50 text-blue-800 border border-blue-200",
      )}>
        <span className="flex-1">{content.message}</span>
        <button onClick={onClose} className="p-0.5 hover:bg-black/10 rounded">
          <span className="material-symbols-outlined text-[18px]">close</span>
        </button>
      </div>
    </div>
  );
}
